import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import { NavigationBar } from 'shared/components/vxl/navigation/NavigationBar/NavigationBar';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

export interface PaymentErrorViewProps {
  accountId: string;
  handleBackAction: () => void;
}

const PaymentError = ({
  accountId,
  handleBackAction,
}: PaymentErrorViewProps) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'makePayment',
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          header: () => (
            <NavigationBar
              title={translatedText('buttons.payCard')}
              primaryIcon={
                <Icon
                  iconKey="BACK"
                  iconSize="MD"
                  iconColor={theme.color.text.primary}
                />
              }
              primaryOnPress={() => {
                handleBackAction();
              }}
            />
          ),
          headerBackVisible: true,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText('error.paymentFailed')}
        messageBody={translatedText('error.tryAgain')}
        primaryButton={{
          title: translatedText('buttons.retry'),
          onPress: () => {
            router.navigate({
              pathname: '/believe/make-payment',
              params: { id: accountId },
            });
          },
          analytics: {
            analyticsId: 'retry',
            customAttributes: { cta: 'Retry' },
          },
        }}
        secondaryButton={{
          title: translatedText('buttons.cancel'),
          onPress: () => {
            router.navigate({
              pathname: '/accounts/manage-account',
              params: { accountId: accountId },
            });
          },
        }}
        screenAnalyticsEventKey="believePaymentError"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    padding: theme.spacing.m,
  },
});

export default PaymentError;
